<template>
  <div class="hajj-mission bg-white py-10">
    <div class="container mx-auto px-4">
      <!-- Заголовок -->
      <h2 class="text-2xl font-bold text-gray-800 mb-6">
        Қазақстан қажылық миссиясы
      </h2>

      <!-- Основной блок -->
      <div class="bg-gray-100 rounded-3xl p-4 flex flex-col lg:flex-row gap-4">
        <!-- Левая часть с изображением -->
        <div class="lg:w-1/2 bg-white rounded-2xl overflow-hidden">
          <div class="aspect-[4/3] lg:aspect-auto h-full max-h-[512px]">
            <img
              :src="activeItem.image"
              alt="Hajj Mission"
              class="w-full h-full object-cover"
            />
          </div>
        </div>

        <!-- Правая часть со списком функций -->
        <div class="lg:w-1/2 space-y-0">
          <!-- Функция 1 -->
          <div
            v-for="(item, index) in missionItems"
            :key="item.title"
            @click="activeIndex = index"
            class="rounded-2xl p-4 flex items-center gap-4 relative cursor-pointer"
            :class="{
              'bg-white': index === activeIndex,
            }"
          >
            <svg-icon
              class="w-8 h-8 flex-shrink-0 text-gray-500"
              :class="{
                'text-primary': index === activeIndex,
              }"
              :name="item.icon"
            />
            <span class="text-gray-800 font-semibold">{{ item.title }}</span>
            <div
              v-if="index === activeIndex"
              class="absolute bottom-0 left-0 w-40 h-0.5 bg-primary"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "HajjMission",
  components: {},
  data() {
    return {
      missionItems: [
        {
          icon: "mission-document",
          title: "Қажылықты ұйымдастыру және қадағалау",
          image: require("@/assets/images/mission/01.jpg"),
        },
        {
          icon: "mission-document",
          title: "Қазақстанға арналған қажылық квотасын алу",
          image: require("@/assets/images/mission/02.jpg"),
        },
        {
          icon: "mission-touroperator",
          title: "Қажылықты ұйымдастыратын туроператорларды бекіту",
          image: require("@/assets/images/mission/03.jpg"),
        },
        {
          icon: "mission-register",
          title: "Қажыларды тіркеу жүйесін қадағалау",
          image: require("@/assets/images/mission/04.jpg"),
        },
        {
          icon: "mission-advise",
          title: "Қажыларға діни мәселелер бойынша кеңес беру",
          image: require("@/assets/images/mission/05.jpg"),
        },
        {
          icon: "mission-check",
          title: "Туроператорлардың қызмет сапасын бақылау",
          image: require("@/assets/images/mission/06.jpg"),
        },
        {
          icon: "mission-security",
          title: "Қажылардың қауіпсіздігін қамтамасыз ету",
          image: require("@/assets/images/mission/07.jpg"),
        },
        {
          icon: "mission-report",
          title: "Қажылық сапарын бағалау және есеп беру",
          image: require("@/assets/images/mission/08.jpg"),
        },
      ],
      activeIndex: 0,
    };
  },
  computed: {
    activeItem() {
      return this.missionItems[this.activeIndex];
    },
  },
});
</script>

<style scoped>
.text-primary {
  color: #3db076;
}

.bg-primary {
  background-color: #3db076;
}
</style>
